import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';

import { appCoreMsgs } from '../locale';

import { errorSelector } from './actionsAndReducer';
import { ISevereErrorSplashProps } from './components/SevereErrorSplash';
import { IErrorSeverity } from './types';

export const selectErrorSeverityFilter = createSelector(
  errorSelector,
  state => (severity: IErrorSeverity) => state.errors.filter(e => e.severity === severity)
);

export const selectWarnings = createSelector(
  selectErrorSeverityFilter,
  filter => filter('warning')
);

export const selectRetryableErrors = createSelector(
  selectErrorSeverityFilter,
  filter => filter('failed-retryable')
);

export const selectNotRetryableErrors = createSelector(
  selectErrorSeverityFilter,
  filter => filter('failed-not-retryable')
);

export const selectSevereErrors = createSelector(
  selectErrorSeverityFilter,
  filter => filter('severe')
);

export const selectHasSevereErrors = createSelector(
  selectSevereErrors,
  errors => errors.size > 0
);

export const selectErrorCount = createSelector(
  errorSelector,
  state => state.errors.size
);

export const selectAllErrors = createSelector(
  errorSelector,
  state => state.errors
);

const selectSevereTitleAndMessage = createSelector(
  selectSevereErrors,
  appCoreMsgs,
  (severeErrors, msgs) => {
    if (severeErrors.size === 0) {
      return { title: null, message: null, code: null };
    }

    const error = severeErrors.first();

    return {
      title: msgs.errors.severeErrorTitle,
      message: msgs.errors.severeErrorMsg,
      code: msgs.errors.severeErrorCode({ code: error.code })
    };
  }
);

export const selectSevereSplashProps = createStructuredSelector<any, ISevereErrorSplashProps>({
  shouldShow: selectHasSevereErrors,
  data: selectSevereTitleAndMessage
});
